module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("CHAPTER")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('h2', {
    staticClass: "h2n"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  }), _vm._v(" 2 "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "Images",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("As soon as we pulled")]), _vm._v(" up to the rescue center, all we could see were happy dog faces and wagging tails. Dogs were everywhere! It was the coolest thing ever.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("There was a woman standing outside the door holding about a billion leashes. Each one had a dog attached to it. There were little dogs and big dogs and black dogs and tan dogs. There ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("were dogs with lots of fur and dogs without much fur at all. I wanted to hug them all!")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom!” I called out as we got closer. She could see the same thing I was seeing, but she didn’t look as excited as I felt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Piper, stay with me,” Mom ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked over at her and wanted to ask why. But the look on her face told me, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Don’t push me, young lady.")]), _vm._v(" I’d seen that look lots of times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, wait . . . I bet I knew what was going on here. Mom didn’t want me to pet the dogs because she knew I’d want to take one home with us. I was just supposed to meet the nice person who owned this place, and then Mom would (maybe) take me for ice cream.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d16a818","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02a.vue
// module id = 72
// module chunks = 0